function hideOnBeta(configuration) {
  'ngInject';
  return {
    restrict: 'C',
    link: function(scope, element) {

      if (configuration.isBeta) {
        angular.element(element).remove();
      }

    }
  };
}

export { hideOnBeta };
